module.exports = __webpack_public_path__ + "c6f6293f7303c538d202f15823ea5fcb.svg";